
<template>
    
        <mars-view class="law-empty" :style="{height: lHeight || 'calc(100vh - 170px)'}"><mars-view><mars-view class="icon iconfont empty-icon" :style="{fontSize: fontSize}"><slot></slot></mars-view><mars-view class="law-empty-text" :style="txtStyle"> {{ txt }}</mars-view></mars-view></mars-view>
    
</template>

<script>
export default {
  props: {
    icons: {
      type: String,
      default: '&#xe649;'
    },
    txt: {
      type: String,
      default: ''
    },
    lHeight: {
      type: String,
      default: ''
    },
    fontSize: {
      type: String,
      default: '110px'
    },
    txtStyle: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.law-empty {
  height: calc(100vh - 170px);
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}
.law-empty .empty-icon {
  font-size: 110px;
  color: #e9e9e9;
  padding-bottom: 0.35rem;
}
.law-empty .law-empty-text {
  font-size: 16px;
  color: #333;
  margin-bottom: 0.4rem;
}

</style>
